type TAnalyticsTab =
  | 'overview'
  | 'events'
  | 'series'
  | 'registrants'
  | 'videos'
  | 'admin';

const DATE_RANGE_TRACKING_VALUES = {
  'last-30-days': 'Last 30 days',
  'last-3-months': 'Last 3 months',
  'last-6-months': 'Last 6 months',
  'last-year': 'Last year',
  custom: 'Custom',
  'all-time': 'All time',
} as const;

export const ADMIN_TOOLTIP_LOCATIONS = {
  activeUsers: 'Active users',
  seatsAssigned: 'Seats assigned',
  totalSeats: 'Total seats',
  topEventCreators: 'Top event creators',
} as const;

type TTabLabelOptions = {
  selectedTab: string;
  enableCHDashboardAnalytics?: boolean;
};

export const getTimeRangeTrackingValue = (dateRange: string): string =>
  DATE_RANGE_TRACKING_VALUES[
    dateRange as keyof typeof DATE_RANGE_TRACKING_VALUES
  ] ?? dateRange;

const getTrackingTabVariant = ({
  selectedTab,
  enableCHDashboardAnalytics,
}: TTabLabelOptions): TAnalyticsTab | 'contact' | 'registrant' | 'video' => {
  if (selectedTab === 'registrants') {
    return enableCHDashboardAnalytics ? 'contact' : 'registrant';
  }

  if (selectedTab === 'videos') {
    return 'video';
  }

  return (selectedTab as TAnalyticsTab) || 'overview';
};

export const getDateRangeTrackingTab = (options: TTabLabelOptions): string =>
  getTrackingTabVariant(options);

export const getExportTrackingTab = (options: TTabLabelOptions): string => {
  const trackingTab = getTrackingTabVariant(options);

  switch (trackingTab) {
    case 'events':
      return 'Event';
    case 'contact':
      return 'Contact';
    case 'registrant':
      return 'Registrant';
    case 'video':
      return 'Videos';
    case 'series':
      return 'Series';
    case 'admin':
      return 'Admin';
    default:
      return 'Overview';
  }
};

export const getAdminSortingOrder = (
  reverse: boolean,
): 'Ascending' | 'Descending' => (reverse ? 'Descending' : 'Ascending');
